import React from 'react'
import { IconProps } from '../../types/types'

const MinusCircleIcon: React.FC<IconProps> = ({ size = '20', color = '#1E1E1E' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.93343 18.3337C14.5168 18.3337 18.2668 14.5837 18.2668 10.0003C18.2668 5.41699 14.5168 1.66699 9.93343 1.66699C5.3501 1.66699 1.6001 5.41699 1.6001 10.0003C1.6001 14.5837 5.3501 18.3337 9.93343 18.3337Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.6001 10H13.2668" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default MinusCircleIcon